import React from 'react'
import { Helmet } from 'react-helmet';

const BunnyKlawzWebsite = () => {
    return (
        <>
            <Helmet>
                <title>BunnyKlawz Case Study | We Are A Site</title>
                <meta name="description" content="Check out our work for BunnyKlawz—a stylish booking site for a nail salon. Built with love and custom features." />
            </Helmet>
            <div className='BunnyKlawzWebsite PortfolioWebsite'>
                <div className='PortfolioWebsiteHeader WebsiteHeader'>
                    <img src='/images/BunnyKlawzIcon.png' alt='Preview' />
                    <div className='WebsiteHeaderInfo'>
                        <span className='BusinessAttribute BusinessName'><span className='BusinessLabel'>Business Name: </span>BunnyKlawz</span>
                        <span className='BusinessAttribute BusinessType'><span className='BusinessLabel'>Business Type: </span>Nail Salon</span>
                        <span className='BusinessAttribute BusinessLaunchYear'><span className='BusinessLabel'>Launch Year: </span> 2025</span>
                        <span className='BusinessAttribute BusinessLink'><span className='BusinessLabel'>Link: </span><a href='https://bunnyklawz.com' target='blank'>https://bunnyklawz.com</a></span>
                    </div>
                </div>
                <div className="WebsiteSection WebsiteDescription">
                    <h1>Description:</h1>
                    <span>A bold and animated site for a nail studio located in Arizona. We crafted an edgy, high-energy experience that lets users immediately start a custom questionnaire to figure out their booking time — making the appointment process super easy and fast. The site also includes user authentication, detailed Services page, a clear Policies page, and plenty of eye-catching animations that bring the brand's playful vibe to life.</span>
                </div>
                <div className="WebsiteSection WebsiteSpecialFeatures">
                    <h1>Special Features:</h1>
                    <span>Animated UI, Brand-Centric Design, User Authentication, Custom Booking Questionnaire and Calendar, Admin Dashboard, Mobile Optimization</span>
                </div>
                <div className="WebsiteSection WebsiteTotalPages">
                    <h1>Total Pages:</h1>
                    <span>Customer Site - 3 pages (Services, Policies and Booking) Admin Site - 5 pages (Calendar, Appointments, Working Hours, Clients, Settings)</span>
                </div>
                <div className="WebsiteSection WebsiteDemo">
                    <h1>Demo:</h1>
                    <span></span>
                    <video
                        controls
                        autoPlay
                        muted
                        loop
                        playsInline
                    >
                        <source
                            src="/videos/BunnyKlawz.mp4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div>

            </div>
        </>

    )
}

export default BunnyKlawzWebsite